import { cn } from '../../../utils/cn';
import { useLanguage } from '../../../features/language/useLanguage';
import type { SalesOrderPaymentStatus } from '../../../types/salesOrder';

const PAYMENT_COLORS: Record<SalesOrderPaymentStatus, string> = {
  paid: 'bg-emerald-100 text-emerald-800',
  unpaid: 'bg-amber-100 text-amber-800',
  // Refunded is distinct from Cancelled (red) — a reversed, settled state.
  refunded: 'bg-slate-200 text-slate-600',
};

const PAYMENT_LABEL_KEYS: Record<SalesOrderPaymentStatus, string> = {
  paid: 'salesOrder.payment.status.paid',
  unpaid: 'salesOrder.payment.status.unpaid',
  refunded: 'salesOrder.payment.status.refunded',
};

interface SalesOrderPaymentBadgeProps {
  paymentStatus: SalesOrderPaymentStatus;
  /** Layout classes for the wrapper (differs between the mobile card and desktop table). */
  className?: string;
}

/** Colored payment pill for a sales order. Orthogonal to the workflow status pill. */
export function SalesOrderPaymentBadge({ paymentStatus, className }: SalesOrderPaymentBadgeProps) {
  const { t } = useLanguage();
  return (
    <span className={cn(PAYMENT_COLORS[paymentStatus] ?? PAYMENT_COLORS.unpaid, className)}>
      {t(PAYMENT_LABEL_KEYS[paymentStatus] ?? PAYMENT_LABEL_KEYS.unpaid, undefined, paymentStatus)}
    </span>
  );
}
